export default "__VITE_ASSET__rf7IOxhC__"